export const queryKeys = {
  listCallRecording: (tenantId: string) => ['phone', 'listCallRecording', tenantId],
};
